import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import RrbWiseIncidentsModal from './RrbWiseIncidentsModal';
import moment from 'moment';
const ReportedIncidentsChart = ({ data, incident_details }) => {
  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );
  const [modalData, setModalData] = useState([]);
  const targetRef = useRef(null);
  const [state, setState] = useState(null);

  useEffect(() => {
    setState({
      series: [
        {
          name: 'Incidents',
          data: data?.data,
        },
      ],
      options: {
        chart: {
          // height:150,
          type: 'bar',
          toolbar: {
            show: true, // Enable or disable the toolbar
            tools: {
              download: false, // Disable the download option
            },
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const selectedCategory = data?.categories[config.dataPointIndex];
              const selectedValue = data?.data[config.dataPointIndex];

              const incidents = incident_details
                .flat() // Flatten the array of arrays
                .filter((incident) => incident.rrb_name === selectedCategory)
                .sort(
                  (b, a) => moment(a.date).valueOf() - moment(b.date).valueOf()
                ); // Sort by date (ascending)

              if (incidents) {
                setModalData(incidents); // Save directly as an array of objects

                setShowIncidentDetailsModal((prev) => ({
                  ...prev,
                  show: true,
                }));
              }
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '50%', // Set bar width as a percentage of the available space (adjust this value)
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        xaxis: {
          categories: data?.categories,
          // position: 'top',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        colors: ['#ED1D24'],
      },
    });
  }, [data]);
  return (
    <>
      {state && (
        <ReactApexChart
          options={state?.options}
          series={state?.series}
          type='bar'
          height={200}
        />
      )}
      {showIncidentDetailsModal.show && (
        <RrbWiseIncidentsModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
        />
      )}
    </>
  );
};
export default ReportedIncidentsChart;
